import { create } from 'zustand'
import { useShallow } from 'zustand/react/shallow'
import { sidebarStore } from './sidebarStore'

type Store = {
  isOpen: boolean
  toggleChat: () => void
  openChat: () => void
  closeChat: () => void
}

export const chatStore = create<Store>((set) => ({
  isOpen: JSON.parse(localStorage.getItem('chatIsOpen') ?? 'false'),
  toggleChat: () =>
    set((state) => {
      const newState = !state.isOpen
      localStorage.setItem('chatIsOpen', JSON.stringify(newState))
      if (newState) {
        sidebarStore.getState().closeSidebar()
      }
      return { isOpen: newState }
    }),
  openChat: () =>
    set(() => {
      const newState = true
      localStorage.setItem('chatIsOpen', JSON.stringify(newState))
      sidebarStore.getState().closeSidebar()
      return { isOpen: newState }
    }),
  closeChat: () =>
    set(() => {
      const newState = false
      localStorage.setItem('chatIsOpen', JSON.stringify(newState))
      return { isOpen: newState }
    }),
}))

export const useChatStore = () => {
  return chatStore(useShallow((s) => s))
}
